import React, { useState, useEffect, useMemo } from 'react';
import api from '../../api';
import { QUALITY_SERVICE_API_URL } from '../../config';
import IssuesTable from './IssuesTable';
import IssuesToolbar from './IssuesToolbar';

export default function IssuesTab({ campaignId, filters, jiraName, emptyFilters, onFiltersChange }) {
  const [search, setSearch] = useState(() => new URLSearchParams(window.location.search).get('q') || '');
  const [includeDesc, setIncludeDesc] = useState(() => new URLSearchParams(window.location.search).get('qd') === '1');
  const [issues, setIssues] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showColumnSelector, setShowColumnSelector] = useState(false);

  // Sync search/includeDesc to URL without touching parent state
  useEffect(() => {
    const url = new URL(window.location.href);
    if (search) url.searchParams.set('q', search); else url.searchParams.delete('q');
    if (includeDesc) url.searchParams.set('qd', '1'); else url.searchParams.delete('qd');
    window.history.replaceState(null, '', url.toString());
  }, [search, includeDesc]);

  const filterKey = useMemo(() =>
    Object.entries(filters)
      .filter(([, v]) => Array.isArray(v) ? v.length > 0 : v)
      .flatMap(([k, v]) => Array.isArray(v) ? v.map(x => `${k}=${x}`) : [`${k}=${v}`])
      .join('&'),
  [filters]);

  useEffect(() => {
    if (!campaignId) return;
    let cancelled = false;
    setLoading(true);

    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (Array.isArray(v)) v.forEach(x => params.append(k, x));
      else if (v) params.append(k, v);
    });
    if (search) { params.set('q', search); if (includeDesc) params.set('qd', '1'); }
    const qs = params.toString() ? `?${params.toString()}` : '';

    api.get(`${QUALITY_SERVICE_API_URL}/hub/campaigns/${campaignId}/issues${qs}`)
      .then(r => { if (!cancelled) { setIssues(r.data); setLoading(false); } })
      .catch(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [campaignId, filterKey, search, includeDesc]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading && issues === null) return <div className="section-loading">Loading…</div>;

  return (
    <>
      <IssuesToolbar
        count={issues?.length ?? 0}
        onSearchChange={setSearch}
        includeDesc={includeDesc}
        onIncludeDescChange={setIncludeDesc}
        jiraName={jiraName}
        filters={filters}
        onFiltersChange={onFiltersChange}
        emptyFilters={emptyFilters}
        onToggleColumns={() => setShowColumnSelector(v => !v)}
      />
      <IssuesTable
        issuesTable={issues ?? []}
        showColumnSelector={showColumnSelector}
        onCloseColumnSelector={() => setShowColumnSelector(false)}
      />
    </>
  );
}
